var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"app-grid-narrow"},[_c('breadcrumbs'),(_vm.togglers.isDataLoaded)?_c('div',{staticClass:"dashboard__body"},[_c('dashboard-table')],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }